module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAUVJREFUWAljZEADjlE1Xv///5vJ8J9BBk2KxlzGx8yMjGl7l7fsQLaICZkDZv/7P4v+jgPZ/F/2L8O/2ejuwXDgf4b/0uiK6MbHEmsYDqSbY4i0aNSBRAYUTmUsOGVwSCSFuTBE+NoysLKQpvX3nz8MK7ccYZi7cjcOk7ELkxzFIZ5WJDsOZDXIQ0HulthdgUeUZAeu23GcARQapAKQnrU7jpGqjYG0eAIaPwcYRSBML0ByCNLLYTB7Rh0ICwly6dEQJDfkYPpGQxAWEuTSgz4ESS6oR+titLRAchSP1sWUhiCafppzSY5imrsIzYJRB6IFCMnc0RAkOcjQNIyGIFqAkMwdrYthQTbaL4aFxGi/GBYSUHq0mEELEJK5QzAEGRmekOxNKmlgZGB8im4URggyMTGkMTAwPkZXSHM+KGCYGIF2owIATjlkX1bCzwsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rectangle.png
// module id = UkQT
// module chunks = 164 166